import React from 'react'

export default function SeparateLine() {
  return <div className='w-[1px] h-[20px] border-l-[1px] border-gray-3' />
}
